import type { JSX } from "react";
import { cn } from "./cn";
import { Icon, type IconName } from "./Icon";

export interface ActionButtonProps {
  readonly label: string;
  readonly variant?: "default" | "primary" | "danger";
  /** Visual weight. `md` is the default and unchanged; `sm` for dense panels. */
  readonly size?: "sm" | "md";
  readonly icon?: string;
  readonly onClick?: () => void;
}

const sizeStyles: Readonly<Record<NonNullable<ActionButtonProps["size"]>, string>> = {
  md: "rounded-[10px] px-4 py-2 text-sm",
  sm: "rounded-lg px-3 py-1.5 text-xs",
};

const variantStyles: Readonly<Record<NonNullable<ActionButtonProps["variant"]>, string>> = {
  default: "bg-surface-hover text-content",
  primary: "bg-green text-white",
  danger: "bg-red text-white",
};

/**
 * Action button used in meeting cards, email detail, etc.
 */
export function ActionButton({ label, variant = "default", size = "md", icon, onClick }: ActionButtonProps): JSX.Element {
  return (
    <button
      className={cn("border-none cursor-pointer inline-flex items-center gap-1.5", sizeStyles[size], variantStyles[variant])}
      type="button"
      onClick={onClick}
    >
      {icon && <Icon name={icon as IconName} size={14} />}
      {label}
    </button>
  );
}
